'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Twine = require('twine');
var lazySizes = require('lazysizes');
var A11yHelpers = require('../global/a11y-helpers');
var AjaxEmailForm = require('./ajax-email-form');
var Nav = require('./nav');
var Popover = require('./popover');
var Signup = require('./signup/signup');
var Subscribe = require('./subscribe');
var CookiesNotice = require('./cookies-notice');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var Twine__default = /*#__PURE__*/_interopDefaultLegacy(Twine);
var lazySizes__default = /*#__PURE__*/_interopDefaultLegacy(lazySizes);
var A11yHelpers__default = /*#__PURE__*/_interopDefaultLegacy(A11yHelpers);
var AjaxEmailForm__default = /*#__PURE__*/_interopDefaultLegacy(AjaxEmailForm);
var Nav__default = /*#__PURE__*/_interopDefaultLegacy(Nav);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);
var Signup__default = /*#__PURE__*/_interopDefaultLegacy(Signup);
var Subscribe__default = /*#__PURE__*/_interopDefaultLegacy(Subscribe);
var CookiesNotice__default = /*#__PURE__*/_interopDefaultLegacy(CookiesNotice);

/* global ShopifyMarketing */

window.ShopifyMarketing = window.ShopifyMarketing || {}; // Signup uses a global Twine context with several references bound in the DOM

window.ShopifyMarketing.context = window.ShopifyMarketing.context || {};
function init() {
  Twine__default.reset(ShopifyMarketing.context).bind().refresh();
  lazySizes__default.init();
  ShopifyMarketing.nav = new Nav__default();
  ShopifyMarketing.signup = new Signup__default();
  new A11yHelpers__default();
  new CookiesNotice__default();
  [...document.getElementsByClassName('js-country-select')].forEach(el => new Popover__default(el));
  [...document.getElementsByClassName('js-ajax')].forEach(el => new AjaxEmailForm__default(el));
  [...document.getElementsByClassName('js-subscribe')].forEach(el => new Subscribe__default(el));
  [...document.getElementsByClassName('js-popover')].forEach(el => new Popover__default(el));
}

exports.default = init;
